import { PermissionsEnum } from "@/auth/interfaces";
import { SelectDateTimerPreScheduling } from "@/erp/sale/component/calendario-preagendamiento-venta/SelectDateTimerPreScheduling";
import useSelectDateTimerPreScheduling, { DepartamentoSelectScheduling } from "@/erp/sale/component/calendario-preagendamiento-venta/useSelectDateTimerPreScheduling.store";
import {
  BucketAwtENUM,
  EstadoPagoChoiceEnum,
  EstadosSolicitudEnumChoice,
  ROUTER_PATHS,
  TipoIdentificacionEnumChoice,
  TipoReferidoEnumChoice,
  comoSeEnteroMockupData,
  convertirFormatoHoraArray,
  fnPasarevision,
  getEnvs,
  gridSizeMdLg10,
  gridSizeMdLg12,
  gridSizeMdLg4,
  gridSizeMdLg6,
  handleErrorForm,
  herramientaUtilizadaMockupData,
  newPreagendamientoSchema,
  numerosMockupData,
  texto,
  tipoDeViviendaMockupData,
  toHour,
  toHours,
  useCheckPermissions,
  useUploadFile,
} from "@/shared";
import {
  useCreatePreagendamiento,
  useFetchAllPromociones,
} from "@/shared/actions/erp";
import { getSolicitudCanje } from "@/shared/actions/erp/marketing";
import { getSolicitudEvento } from "@/shared/actions/erp/marketing/solicitudEvento.action";
import {
  CustomAutocomplete,
  CustomNumberTextField,
  CustomTextArea,
  CustomTextField,
  CustomTextFieldNoForm,
  LoaderComponent,
  StepperBoxScene,
  TabTextLabel,
} from "@/shared/components/ui";
import { openGenericObjectModalAsync } from "@/shared/components/ui/ModalGenericObject/useGenericObjectModalStore";
import TablaEquipoAdicionalComponente from "@/shared/components/ui/TablaEquipoAdicionalComponente/TablaEquipoAdicionalComponente";
import ImageUploadComponente from "@/shared/components/ui/UploadImage/ImageUploadComponente";
import {
  CacheKeyCalendarioENUM,
  DescripcionPagoInstall,
  ErrorMessagesForm,
  IFormPreagendamiento,
  IPromocion,
  NacionalidadEnum,
  PaymentMethodEnum,
  TipoSolicitudesEnum,
} from "@/shared/interfaces";
import { fieldCanje, fieldEvento } from "@/shared/utils/fields-modal-generic-object";
import { useAuthStore } from "@/store/auth";
import { useNapsStore } from "@/store/erp/mantenimiento-operacion/naps.store";
import { useUiStore } from "@/store/ui";
import GlobeEuropeAfricaIcon from "@heroicons/react/24/solid/GlobeEuropeAfricaIcon";
import { yupResolver } from "@hookform/resolvers/yup";
import { Visibility } from "@mui/icons-material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import FacebookIcon from "@mui/icons-material/Facebook";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import RedditIcon from "@mui/icons-material/Reddit";
import VideogameAssetIcon from "@mui/icons-material/VideogameAsset";
import YouTubeIcon from "@mui/icons-material/YouTube";
import {
  Alert,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  InputAdornment,
  SvgIcon,
  Typography,
} from "@mui/material";
import "dayjs/locale/es";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const {
  VITE_NODE_ENV
} = getEnvs()

const steps = ["Informacion", "Servicio", "Instalación", "Otros", "Encuesta"];

interface SavePreagendamientoProps {
  title: string
  //dataPreventa: IDataPreventa
  dataPreventa: any
}

export default function SavePreagendamientoVenta({
  title,
  dataPreventa
}: SavePreagendamientoProps) {
  useCheckPermissions(PermissionsEnum.api_add_preagendamiento);

  ///* STATE

  const getFloat = useSelectDateTimerPreScheduling(s => s.getFloat);
  const stopAndResetTemporizer = useSelectDateTimerPreScheduling(s => s.stopAndResetTemporizer);
  const selectFloat = useSelectDateTimerPreScheduling(s => s.selectFloat);
  const isLoadingFloat = useSelectDateTimerPreScheduling(s => s.isLoadingFloat);
  const selectDate = useSelectDateTimerPreScheduling(s => s.selectDate);
  const slot = useSelectDateTimerPreScheduling(s => s.slot);
  const setPreventa = useSelectDateTimerPreScheduling(s => s.setPreventa);
  const unblockPlanification = useSelectDateTimerPreScheduling(s => s.unblockPlanification);
  const setConfigParams = useSelectDateTimerPreScheduling(s => s.setConfigParams);
  const setIsSave = useSelectDateTimerPreScheduling(s => s.setIsSave);

  //const setAlert = useUiStore((s) => s.setAlert);
  const [imgComprobantePago, setImgComprobantePago] = useState<File | null>(
    null
  );
  const [dialogContrato, setDialogContrato] = useState(false);

  ///* FORMULARIO PARA PREVENTAS
  // PERF: interfaz flaca (era useForm<IFormPreagendamiento>, explotaba Path<T>)
  const form = useForm<{ como_se_entero: string; coordenadas: string; detalle_instalacion: string; distancia: string; distancia_polmax: string; domotica: any; entretenimiento: any; herramienta_utilizada: string; juegos: any; nap: string; nap_nombre: string; numero_comprobante: string; numero_dispositivos: string; numero_pisos: string; promocion: string; promocion_2: string; promocion_3: string; redes_sociales: any; streaming: any; tipo_vivienda: string; trabajo_estudio: any }>({
    resolver: yupResolver(newPreagendamientoSchema) as any,
  });

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = form;

  //FETCH

  const navigate = useNavigate();

  const {
    mutateAsync: createPreagendamiento,
    isPending: isPendingPreagendamiento,
  } = useCreatePreagendamiento({});
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);

  const {
    data: dataPromocion,
    isLoading: isLoadingPromocion
  } = useFetchAllPromociones({});

  const {
    isLoadingNaps: isLoadingNapsByCity,
    getNaps,
    naps: napsByCity,
  } = useNapsStore();


  const {
    handleUploadFile
  } = useUploadFile();


  useEffect(() => {

    if (!dataPreventa) return;

    if (
      dataPreventa?.estado_preventa != EstadosSolicitudEnumChoice.EN_ESPERA
    ) {
      navigate(ROUTER_PATHS.ventas.preventasNav);
      toast.info(
        "Preagendamiento ya fue asiganado.",
      );
      return;
    }

    const splitCoor = dataPreventa.coordenadas.split(",");

    getNaps({
      lat: splitCoor.at(0),
      lng: splitCoor.at(1),
      page_size: 1000,
    });


    reset({
      ...form.getValues(),
      detalle_instalacion: `EL PLAN "${dataPreventa?.plan_data?.nombre}" CON EL TIPO DE INSTALACION "${dataPreventa?.tipo_instalacion_data.nombre}" TIENE UN COSTO DE "$${dataPreventa?.valor_instalacion_total}" `,
    });


  }, [dataPreventa.id_preventa]);

  useEffect(() => {
    if (!isLoadingNapsByCity) {
      const napS = napsByCity.find((s) => s.codigo == dataPreventa?.nap!);

      console.log(napS, "napS");

      reset({
        ...form.getValues(),
        nap: dataPreventa?.nap,
        nap_nombre: dataPreventa?.nap_data?.nombre,
        distancia_polmax: napS ? napS?.distancia_polmax.toFixed(2) : "0",
        distancia: napS ? napS?.distancia.toFixed(2) : "0",
      });
    }
  }, [isLoadingNapsByCity]);

  const departamento_nombre = useAuthStore(s => s.user)?.departamento_nombre
  // cargar planificador
  useEffect(() => {


    setConfigParams(
      {
        time: VITE_NODE_ENV == 'prod'
          ? 10 * 60 * 1000
          : 60 * 1000,
        tiempo: VITE_NODE_ENV == 'prod'
          ? CacheKeyCalendarioENUM.TIEMPO_LIMITE
          : CacheKeyCalendarioENUM.TIEMPO_LIMITE_PYL,
        motivo: CacheKeyCalendarioENUM.MENSAJE_BLOQUEO,
        departamento: departamento_nombre ?? DepartamentoSelectScheduling.VENTA
      }
    )

    if (!dataPreventa) return;

    (async () => {
      await Promise.all([
        getFloat({
          estado: true,
          zonas: dataPreventa?.zona
        }),
        setPreventa(dataPreventa.id_preventa)
      ]);
    })();


    return () => {
      console.log('liberar agendamiento');
      unblockPlanification()
    }
  }, [dataPreventa.id_preventa])


  //* stepper
  const [activeStep, setActiveStep] = useState(0);
  const [disableNextStepBtn] = useState(false);
  const [skipped, setSkipped] = useState(new Set<number>());

  const handleNext = () => {
    let newSkipped = skipped;
    if (activeStep === steps.length - 1) return;
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const onSubmit = async (data: IFormPreagendamiento) => {
    try {

      setIsSave(true)
      if (selectDate == null || slot == null || selectFloat == null)
        return toast.error(
          "Selecionar un técnico con fecha y hora de instalación.",
        );

      if (imgComprobantePago && !form.getValues().numero_comprobante)
        return toast.error(
          "Ingresar un número de comprobante",
        );

      if (
        !imgComprobantePago &&
        form.getValues().numero_comprobante &&
        dataPreventa?.forma_pago_data?.forma_pago ==
        PaymentMethodEnum.RECAUDACION
      )
        return toast.error(
          "Cargar imagen del comprobante de pago",
        );


      const jsonUsos = {
        trabajo_estudio: !!form.getValues().trabajo_estudio,
        entretenimiento: !!form.getValues().entretenimiento,
        juegos: !!form.getValues().juegos,
        redes_sociales: !!form.getValues().redes_sociales,
        streaming: !!form.getValues().streaming,
        domotica: !!form.getValues().domotica,
      };

      const jsonEncuesta = {
        como_se_entero: form.getValues().como_se_entero,
        herramienta_utilizada: form.getValues().herramienta_utilizada,
        tipo_vivienda: form.getValues().tipo_vivienda,
        numero_pisos: form.getValues().numero_pisos,
        numero_dispositivos: form.getValues().numero_dispositivos,
      };

      if (imgComprobantePago && form.getValues().numero_comprobante) {
        const foto_aceptacion_cliente = await handleUploadFile(
          imgComprobantePago,
          BucketAwtENUM.IMAGE_COMPRABANTE_PAGO
        );
        data.url_foto_comprobante = foto_aceptacion_cliente.url;
        data.numero_comprobante = form.getValues().numero_comprobante;
      }

      // Determinar forma de pago - priorizar V2 si existe, sino usar V1
      // Mapear tipo_pago_v2 a los valores válidos de estado_pago:
      // CRÉDITO -> TARJETA (para "PAGADO TARJETA")
      // DÉBITO -> DÉBITO (para "PAGADO DÉBITO")
      let formaPagoTipo = dataPreventa?.tipo_pago_v2
        ? dataPreventa.tipo_pago_v2
        : dataPreventa?.forma_pago_data?.forma_pago || "";

      // Mapear CRÉDITO a TARJETA para compatibilidad con ESTADOS_PAGO del backend
      if (formaPagoTipo === "CRÉDITO") {
        formaPagoTipo = PaymentMethodEnum.TARJETA;
      }

      data.descripcion_pago = fnPasarevision(formaPagoTipo)
        ? DescripcionPagoInstall.INSTALACION_GRATUITA
        : DescripcionPagoInstall.PENDIENTE;

      //data.estado_pago = dataPreventa?.forma_pago_data?.forma_pago
      data.estado_pago =
        formaPagoTipo === PaymentMethodEnum.RECAUDACION && +dataPreventa.valor_instalacion > 0
          ? `${EstadoPagoChoiceEnum.PENDIENTE}`
          : `${EstadoPagoChoiceEnum.PAGADO} ${formaPagoTipo}`;

      data.usos = jsonUsos;
      data.encuesta = jsonEncuesta;
      data.prospecto = dataPreventa?.prospecto_data.codigo;
      data.preventa = dataPreventa?.codigo;
      data.flota = selectFloat!
      data.fecha_instalacion = selectDate.format("YYYY-MM-DD");
      data.hora_instalacion = toHour(slot!.hora)

      //data.horas = convertirFormatoHoraArray(horasSelect);
      data.horas = convertirFormatoHoraArray(toHours(slot!.hora))

      const resp = await createPreagendamiento(data);

      if (resp.code != 200) {
        return toast.error("Error al crear el preagendamiento");
      }

      stopAndResetTemporizer()

      if (dataPreventa?.requiere_contrato_fisico) {
        toast.success(
          "Preagendamiento creado correctamente.",
        );
        navigate(ROUTER_PATHS.ventas.preAgendamientoNav);
      } else {
        setDialogContrato(true);
      }
    } catch (error) {
    } finally {
      setIsGlobalLoading(false);
    }
  };

  const handleValidarTipoVenta = useMemo(() => {
    const dataProspecto = dataPreventa.prospecto_data;

    if (dataProspecto.solicitud_canje) {
      return TipoSolicitudesEnum.CANJE
    }
    if (dataProspecto.solicitud_evento) {
      return TipoSolicitudesEnum.EVENTO
    }
    return TipoSolicitudesEnum.HOGAR
  }, [dataPreventa.id_preventa])

  if (
    isLoadingNapsByCity ||
    isLoadingFloat
  )
    return <LoaderComponent />;

  return (
    <StepperBoxScene
      py={0}
      titlePage={title}
      num_referencia={`${dataPreventa.prospecto_data.razon_social} L${dataPreventa.prospecto_data.linea}`}
      steps={steps}
      activeStep={activeStep}
      handleNext={handleNext}
      handleBack={handleBack}
      disableNextStepBtn={disableNextStepBtn}
      onCancel={async () => {
        navigate(ROUTER_PATHS.ventas.preventasNav);
      }}
      onSave={handleSubmit(onSubmit as any, (error) => {
        handleErrorForm(error as ErrorMessagesForm);
      })}
      size={gridSizeMdLg10}

      additionalNoteText={
        <Grid container
          justifyContent={'space-between'}
          alignContent={'center'}
          alignItems={'center'}
        >
          <Grid item >
            Cliente <b>{handleValidarTipoVenta}</b>
          </Grid>

          {
            [TipoSolicitudesEnum.CANJE,
            TipoSolicitudesEnum.EVENTO,]
              .includes(handleValidarTipoVenta as TipoSolicitudesEnum) && (
              <Grid item >
                <Button
                  startIcon={<Visibility />}
                  onClick={() => {

                    const solicitud_canje = dataPreventa.prospecto_data.solicitud_canje;
                    const solicitud_evento = dataPreventa.prospecto_data.solicitud_evento;

                    openGenericObjectModalAsync({
                      fetcher: async () => {
                        if (solicitud_canje) {
                          const resp = await getSolicitudCanje({
                            codigo: solicitud_canje
                          })
                          return resp.data.data[0]
                        }

                        const resp = await getSolicitudEvento({
                          codigo: solicitud_evento
                        })

                        return resp.data.data[0]
                      },

                      fields: solicitud_canje
                        ? fieldCanje
                        : fieldEvento,
                      title: 'Información',
                    })
                  }}
                >
                  VER INFORMACIÓN
                </Button>
              </Grid>
            )
          }

        </Grid>
      }

    >
      {activeStep === 0 && (
        <Grid container spacing={3}>
          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={texto.informacion_personal}
              pt={0}
              mt={0}
              pb={0}
              pl={0}
            />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.tipo_documento}
            defaultValue={dataPreventa?.prospecto_data.tipo_identificacion}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.identificacion}
            defaultValue={dataPreventa?.prospecto_data.identificacion}
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            disabled={true}
            label={texto.nombre_apellido}
            defaultValue={dataPreventa?.prospecto_data.razon_social}
            size={gridSizeMdLg6}
          />

          {dataPreventa?.prospecto_data.tipo_identificacion !=
            TipoIdentificacionEnumChoice.RUC && (
              <>
                <CustomTextFieldNoForm
                  disabled={true}
                  label={texto.fecha_nacimiento}
                  defaultValue={dataPreventa?.prospecto_data.fecha_nacimiento}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={texto.edad}
                  defaultValue={dataPreventa?.prospecto_data.edad}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={texto.nacionalidad}
                  defaultValue={
                    dataPreventa?.prospecto_data.nacionalidad ===
                      NacionalidadEnum.CODIGO
                      ? NacionalidadEnum.ECUATORIANA
                      : dataPreventa?.prospecto_data.nacionalidad
                  }
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={texto.condicion_residencia}
                  defaultValue={dataPreventa?.condicion_residencia}
                  size={gridSizeMdLg6}
                />
              </>
            )}

          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel text={texto.localidad} pt={0} mt={0} pb={0} pl={0} />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={"País"}
            defaultValue={NacionalidadEnum.ECUATORIANA || ""}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.provincia}
            defaultValue={dataPreventa?.provincia_data?.nombre}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.city}
            defaultValue={dataPreventa?.ciudad_data?.nombre}
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            disabled={true}
            label={texto.zona}
            defaultValue={dataPreventa?.zona_data?.nombre}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.sector}
            defaultValue={dataPreventa?.sector_data?.nombre}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.direccion}
            defaultValue={dataPreventa?.direccion}
            size={gridSizeMdLg6}
          />

          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={texto.datos_buros}
              pt={0}
              mt={0}
              pb={0}
              pl={0}
            />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.segmentacion}
            defaultValue={dataPreventa?.prospecto_data.segmentacion}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.puntaje_score_empresa}
            defaultValue={dataPreventa?.prospecto_data.puntaje_score_empresa}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.puntaje_score_empresa}
            defaultValue={
              dataPreventa?.prospecto_data.puntaje_score_sobreendeudamiento
            }
            size={gridSizeMdLg6}
          />

          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={texto.contacto_cliente}
              pt={0}
              mt={0}
              pb={0}
              pl={0}
            />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.celular}
            defaultValue={dataPreventa?.prospecto_data.celular}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            required={false}
            label={texto.telefono_adicional}
            defaultValue={dataPreventa?.celular_2}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.email}
            defaultValue={dataPreventa?.email}
            size={gridSizeMdLg6}
          />

          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={texto.contacto_referencia}
              pt={0}
              mt={0}
              pb={0}
              pl={0}
            />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.persona_referido}
            defaultValue={dataPreventa?.persona_referencia_nombre}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.celular_referencia}
            defaultValue={dataPreventa?.persona_referencia_celular}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            required={false}
            label={texto.telefono_fijo_referencia}
            defaultValue={dataPreventa?.persona_referencia_celular_2}
            size={gridSizeMdLg6}
          />
        </Grid>
      )}

      {activeStep === 1 && (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TabTextLabel text={texto.servicio} mt={0} pb={0} pl={0} pt={0} />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.tipo_servicio}
            defaultValue={dataPreventa?.tipo_servicio}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.plan}
            defaultValue={dataPreventa?.plan_data?.nombre}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.velocidad_internet}
            defaultValue={
              dataPreventa?.velocidad + " " + dataPreventa?.plan_data?.unidad ||
              ""
            }
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.tipo_instalacion}
            defaultValue={dataPreventa?.tipo_instalacion}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.valor_instalacion}
            defaultValue={dataPreventa?.valor_instalacion || ""}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.valor_instalacion_total}
            defaultValue={dataPreventa?.valor_instalacion_total}
            size={gridSizeMdLg6}
          />

          {+dataPreventa!.valor_instalacion > 0 &&
            dataPreventa?.forma_pago_data?.forma_pago ==
            PaymentMethodEnum.RECAUDACION && (
              <>
                <Grid item xs={12}>
                  <TabTextLabel
                    text={texto.comprobante_pago}
                    mt={0}
                    pb={0}
                    pl={0}
                    pt={0}
                  />
                </Grid>

                <CustomTextFieldNoForm
                  disabled={true}
                  label={texto.forma_pago}
                  defaultValue={dataPreventa?.forma_pago_data.alias ?? ""}
                  size={gridSizeMdLg6}
                />

                <CustomTextField
                  type="text"
                  control={form.control}
                  //placeholder="Ingresar el Número de Comprobante"
                  name="numero_comprobante"
                  defaultValue={form.getValues().numero_comprobante}
                  size={gridSizeMdLg6}
                  label={"Número de Comprobante"}
                  error={errors.numero_comprobante}
                  helperText={errors.numero_comprobante?.message}
                />

                <Grid item {...gridSizeMdLg12}>
                  <ImageUploadComponente
                    idInput="comprobante-pago"
                    buttonText={texto.comprobante_pago}
                    selectedImage={imgComprobantePago}
                    setSelectedImage={setImgComprobantePago}
                    imageUrl={""}
                  />
                </Grid>
              </>
            )}
        </Grid>
      )}

      {activeStep === 2 && (
        <Grid container spacing={3}>
          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={texto.coordenadas_usuario}
              pt={0}
              mt={0}
              pb={0}
              pl={0}
            />
          </Grid>

          <CustomTextField
            disabled={true}
            type="coordenada"
            control={form.control}
            name="coordenadas"
            defaultValue={dataPreventa?.coordenadas}
            size={gridSizeMdLg12}
            label={texto.coordenadas}
            error={errors.coordenadas}
            startAdornment={
              <InputAdornment position="start">
                <SvgIcon fontSize="small">
                  <GlobeEuropeAfricaIcon />
                </SvgIcon>
              </InputAdornment>
            }
            helperText={errors.coordenadas?.message}
          />

          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={texto.instalaciones}
              pt={0}
              mt={0}
              pb={0}
              pl={0}
            />
          </Grid>

          <CustomTextArea
            disabled={true}
            label={texto.detalle_instalacion}
            name="detalle_instalacion"
            control={form.control}
            defaultValue={form.getValues().detalle_instalacion}
            error={errors.detalle_instalacion}
            helperText={errors.detalle_instalacion?.message}
            required={false}
            rows={3}
          />

          {form.getValues().nap != null && (
            <>
              <CustomTextField
                disabled={true}
                type="text"
                control={form.control}
                //placeholder="Ingresar el Número de Comprobante"
                name="nap_nombre"
                defaultValue={form.getValues().nap_nombre || ""}
                size={gridSizeMdLg4}
                label={"Nap"}
                error={errors.nap_nombre}
                helperText={errors.nap_nombre?.message}
              />

              <CustomNumberTextField
                disabled={true}
                name="distancia"
                label={"Distancia"}
                defaultValue={form.getValues().distancia || ""}
                control={form.control}
                error={errors.distancia}
                helperText={errors.distancia?.message}
                endAdornment={
                  <InputAdornment position="start">
                    <Typography variant="body2">Metros</Typography>
                  </InputAdornment>
                }
                size={gridSizeMdLg4}
              />

              <CustomNumberTextField
                disabled={true}
                name="distancia_polmax"
                label={"Distancia Max."}
                defaultValue={form.getValues().distancia_polmax || ""}
                control={form.control}
                error={errors.distancia_polmax}
                helperText={errors.distancia_polmax?.message}
                endAdornment={
                  <InputAdornment position="start">
                    <Typography variant="body2">Metros</Typography>
                  </InputAdornment>
                }
                size={gridSizeMdLg4}
              />

              <Grid item xs={12}>
                <Typography
                  variant="subtitle2"
                  style={{
                    color: "#6C737F",
                  }}
                >
                  Nota: Los valores de Distancia y Distancia Máx. son solo
                  referencias para la distancia aproximada entre la NAP y la
                  ubicación del usuario.
                </Typography>
              </Grid>
            </>
          )}

          {/*SELECION DE FECHA Y HORA DE INSTALACION*/}

          <Grid item xs={12}>
            <SelectDateTimerPreScheduling />
          </Grid>

          {/* <CalendarioPreagendamientoVenta
            form={form}
            key="preagendamiento-calendario-venta"
          /> */}
        </Grid>
      )}

      {activeStep === 3 && (
        <Grid container spacing={3}>
          <Grid
            item
            spacing={1}
            {...gridSizeMdLg12}
            justifyContent={"space-between"}
            display={"flex"}
          >
            <TabTextLabel text="Promociones" pt={0} mt={0} pb={0} pl={0} />


          </Grid>



          {(!dataPreventa?.promociones ||
            dataPreventa.promociones.length === 0) && (
              <Grid item {...gridSizeMdLg12}>
                <Alert
                  color="info"
                  variant="outlined"
                >El cliente no aplica promoción.</Alert>
              </Grid>
            )}
          {dataPreventa?.promociones[0] && (
            <CustomAutocomplete<IPromocion>
              disabled={true}
              size={gridSizeMdLg12}
              label={"Promoción 1"}
              name="promocion"
              options={dataPromocion?.data.data || []}
              valueKey="nombre"
              defaultValue={dataPreventa?.promociones[0] || "N/A"}
              actualValueKey="id_promocion"
              isLoadingData={isLoadingPromocion}
              control={control}
              error={undefined}
              helperText={undefined}
            />
          )}

          {dataPreventa?.promociones[1] && (
            <CustomAutocomplete<IPromocion>
              disabled={true}
              size={gridSizeMdLg12}
              label={"Promoción 2"}
              name="promocion_2"
              options={dataPromocion?.data.data || []}
              valueKey="nombre"
              defaultValue={dataPreventa?.promociones[1] || "N/A"}
              actualValueKey="id_promocion"
              isLoadingData={isLoadingPromocion}
              control={control}
              error={undefined}
              helperText={undefined}
            />
          )}

          {dataPreventa?.promociones[2] && (
            <CustomAutocomplete<IPromocion>
              disabled={true}
              size={gridSizeMdLg12}
              label={"Promoción 3"}
              name="promocion_3"
              options={dataPromocion?.data.data || []}
              valueKey="nombre"
              defaultValue={dataPreventa?.promociones[2] || "N/A"}
              actualValueKey="id_promocion"
              isLoadingData={isLoadingPromocion}
              control={control}
              error={undefined}
              helperText={undefined}
            />
          )}




          <Grid item xs={12}>
            <TabTextLabel text="Referido" pt={0} mt={0} pb={0} pl={0} />
          </Grid>

          {dataPreventa?.referido_flota && (
            <>
              <CustomTextFieldNoForm
                disabled={true}
                label={"Tipo de Referido"}
                defaultValue={TipoReferidoEnumChoice.FLOTA}
                size={gridSizeMdLg6}
              />
              <CustomTextFieldNoForm
                disabled={true}
                label={"Nombre Flota"}
                defaultValue={dataPreventa?.referido_flota_data?.nombre}
                size={gridSizeMdLg6}
              />

              <CustomTextFieldNoForm
                disabled={true}
                label={"Lider"}
                defaultValue={dataPreventa?.referido_flota_data?.lider}
                size={gridSizeMdLg6}
              />

              <CustomTextFieldNoForm
                disabled={true}
                label={"Telefono 1"}
                defaultValue={dataPreventa?.referido_flota_data?.telefono_1}
                size={gridSizeMdLg6}
              />
              <CustomTextFieldNoForm
                disabled={true}
                label={"Telefono 2"}
                defaultValue={dataPreventa?.referido_flota_data?.telefono_2}
                size={gridSizeMdLg6}
              />
            </>
          )}

          {dataPreventa?.referido_cliente_data && (
            <>
              <CustomTextFieldNoForm
                disabled={true}
                label={"Tipo de Referido"}
                defaultValue={TipoReferidoEnumChoice.CLIENTE}
                size={gridSizeMdLg6}
              />
              <CustomTextFieldNoForm
                disabled={true}
                label={"Nombre"}
                defaultValue={
                  dataPreventa?.referido_cliente_data?.razon_social || ""
                }
                size={gridSizeMdLg6}
              />

              <CustomTextFieldNoForm
                disabled={true}
                label={texto.identificacion}
                defaultValue={
                  dataPreventa?.referido_cliente_data?.identificacion || ""
                }
                size={gridSizeMdLg6}
              />

              <CustomTextFieldNoForm
                disabled={true}
                label={texto.email}
                defaultValue={dataPreventa?.referido_cliente_data?.email || ""}
                size={gridSizeMdLg6}
              />

              <CustomTextFieldNoForm
                disabled={true}
                label={texto.celular}
                defaultValue={
                  dataPreventa?.referido_cliente_data?.celular || ""
                }
                size={gridSizeMdLg6}
              />
            </>
          )}

          {!dataPreventa?.referido_cliente_data &&
            !dataPreventa?.referido_flota_data && (
              <Grid item xs={12} justifyContent={"center"}>
                <Alert
                  color="info"
                  variant="outlined"
                >El cliente no tiene referido.</Alert>
              </Grid>
            )}

          <Grid
            item
            spacing={1}
            {...gridSizeMdLg12}
            justifyContent={"space-between"}
            display={"flex"}
          >
            <TabTextLabel
              text="Equipos Adicionales"
              pt={0}
              mt={0}
              pb={0}
              pl={0}
            />
          </Grid>

          <Grid item xs={12}>
            <TablaEquipoAdicionalComponente
              equipos_adicionales={dataPreventa?.equipos_adicionales ?? []}
            />

          </Grid>

        </Grid>
      )}

      {activeStep === 4 && (
        <Grid container spacing={3}>
          <CustomAutocomplete<any>
            size={gridSizeMdLg6}
            label={texto.como_se_entero}
            name="como_se_entero"
            options={comoSeEnteroMockupData || []}
            valueKey="nombre" // name is the fk
            actualValueKey="nombre"
            defaultValue={form.getValues().como_se_entero}
            isLoadingData={false}
            control={control}
            error={errors.como_se_entero}
            helperText={errors.como_se_entero?.message}
          />

          <CustomAutocomplete<any>
            size={gridSizeMdLg6}
            label={texto.herramienta_utilizada}
            name="herramienta_utilizada"
            options={herramientaUtilizadaMockupData || []}
            valueKey="nombre"
            actualValueKey="nombre"
            defaultValue={form.getValues().herramienta_utilizada}
            isLoadingData={false}
            control={control}
            error={errors.herramienta_utilizada}
            helperText={errors.herramienta_utilizada?.message}
          />

          <CustomAutocomplete<any>
            size={gridSizeMdLg6}
            label={texto.tipo_vivienda}
            name="tipo_vivienda"
            options={tipoDeViviendaMockupData || []}
            valueKey="nombre"
            actualValueKey="nombre"
            defaultValue={form.getValues().tipo_vivienda}
            isLoadingData={false}
            control={control}
            error={errors.tipo_vivienda}
            helperText={errors.tipo_vivienda?.message}
          />

          <CustomAutocomplete<any>
            size={gridSizeMdLg6}
            label={texto.numero_pisos}
            name="numero_pisos"
            options={numerosMockupData || []}
            valueKey="nombre"
            actualValueKey="nombre"
            defaultValue={form.getValues().numero_pisos}
            isLoadingData={false}
            control={control}
            error={errors.numero_pisos}
            helperText={errors.numero_pisos?.message}
          />

          <CustomAutocomplete<any>
            size={gridSizeMdLg6}
            label={texto.numero_dispositivos}
            name="numero_dispositivos"
            options={numerosMockupData || []}
            valueKey="nombre"
            actualValueKey="nombre"
            defaultValue={form.getValues().numero_dispositivos}
            isLoadingData={false}
            control={control}
            error={errors.numero_dispositivos}
            helperText={errors.numero_dispositivos?.message}
          />

          <Grid item xs={12}>
            <Typography variant="subtitle1" textAlign={"center"}>
              Tipo de uso
            </Typography>
          </Grid>

          <Grid item {...gridSizeMdLg4}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  name="trabajo_estudio"
                  value={"trabajo/estudio"}
                  defaultChecked={!!form.getValues("trabajo_estudio")}
                  checked={!!form.getValues("trabajo_estudio")}
                  icon={<HomeWorkIcon />}
                  checkedIcon={<CheckBoxIcon />}
                  onChange={(e) => {
                    reset({
                      ...form.getValues(),
                      trabajo_estudio: e.target.checked,
                    });
                  }}
                />
              }
              label="Trabajo/Estudio"
            />
          </Grid>
          <Grid item {...gridSizeMdLg4}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  name="entretenimiento"
                  value={"entretenimiento"}
                  defaultChecked={!!form.getValues("entretenimiento")}
                  checked={!!form.getValues("entretenimiento")}
                  icon={<YouTubeIcon />}
                  checkedIcon={<CheckBoxIcon />}
                  onChange={(e) => {
                    reset({
                      ...form.getValues(),
                      entretenimiento: e.target.checked,
                    });
                  }}
                />
              }
              label="Entretenimiento"
            />
          </Grid>

          <Grid item {...gridSizeMdLg4}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  name="juegos"
                  value={"juegos"}
                  defaultChecked={!!form.getValues("juegos")}
                  checked={!!form.getValues("juegos")}
                  icon={<VideogameAssetIcon />}
                  checkedIcon={<CheckBoxIcon />}
                  onChange={(e) => {
                    reset({ ...form.getValues(), juegos: e.target.checked });
                  }}
                />
              }
              label="Juegos"
            />
          </Grid>

          <Grid item {...gridSizeMdLg4}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  name="redes_sociales"
                  value={"redes_sociales"}
                  defaultChecked={!!form.getValues("redes_sociales")}
                  checked={!!form.getValues("redes_sociales")}
                  icon={<FacebookIcon />}
                  checkedIcon={<CheckBoxIcon />}
                  onChange={(e) => {
                    reset({
                      ...form.getValues(),
                      redes_sociales: e.target.checked,
                    });
                  }}
                />
              }
              label="Redes Sociales"
            />
          </Grid>

          <Grid item {...gridSizeMdLg4}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  name="streaming"
                  value={"streaming"}
                  defaultChecked={!!form.getValues("streaming")}
                  checked={!!form.getValues("streaming")}
                  icon={<LiveTvIcon />}
                  checkedIcon={<CheckBoxIcon />}
                  onChange={(e) => {
                    reset({
                      ...form.getValues(),
                      streaming: e.target.checked,
                    });
                  }}
                />
              }
              label="Streaming"
            />
          </Grid>

          <Grid item {...gridSizeMdLg4}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  name="domotica"
                  value={"domotica"}
                  defaultChecked={!!form.getValues("domotica")}
                  checked={!!form.getValues("domotica")}
                  icon={<RedditIcon />}
                  checkedIcon={<CheckBoxIcon />}
                  onChange={(e) => {
                    reset({
                      ...form.getValues(),
                      domotica: e.target.checked,
                    });
                  }}
                />
              }
              label="Domótica"
            />
          </Grid>
        </Grid>
      )}

      {!isPendingPreagendamiento && dialogContrato && (
        <Dialog open={dialogContrato}>
          <DialogTitle>{"¡Preagendamiento creado con éxito!"}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} justifyContent={"end"}>
              <Grid item xs={12}>
                <Typography>
                  {`El siguiente paso es coordinar con el departamento PYL. Puedes dar seguimiento a la venta en el módulo de agendamiento o solicitar información a través de la bitácora.`}
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => {
                setDialogContrato(false);
                navigate(ROUTER_PATHS.ventas.preAgendamientoNav);
              }}
            >
              {"Salir"}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </StepperBoxScene>
  );
}
